/*
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 */

import keyMirror = require('keymirror');

const actionTypes = keyMirror({
  RECEIVE_PORTAL_BUILD_INFO: null,
  LICENSE_AGREEMENT_GET: null,
  LICENSE_AGREEMENT_SET: null,
});

const modal = keyMirror({
  portalAboutInfo: null,
  portalLicenseAgreement: null,
});

const paths = {
  odysseus: () => 'http://odysseusinc.com/',
};

const images = {
  logo: '/icons/logo/logo_odys.svg',
};

const LICENSE_AGREEMENT_KEY = 'license-agreement';
const acceptanceExpiresInDays = 10;

export {
  actionTypes,
  images,
  modal,
  paths,
  LICENSE_AGREEMENT_KEY,
  acceptanceExpiresInDays,
};
